/**
 *
 * @module sdk
 * @desc {BAM.SDK} entry point (core).
 *
 */

import Account from './account/entry';
import Commerce from './commerce/entry';
import Configuration from './configuration/entry';
import Content from './content/entry';
import CustomerService from './customerService/entry';
import Device from './device/entry';
import Drm from './drm/entry';
import Identity from './identity/entry';
import Internal from './internal/entry';
import Logging from './logging/entry';
import Media from './media/entry';
import Paywall from './paywall/entry';
import Purchase from './purchase/entry';
import Services from './services/entry';
import Sequences from './sequences/entry';
import Status from './status/entry';
import Subscription from './subscription/entry';
import Token from './token/entry';
import Session from './session/entry';
import UserActivity from './userActivity/entry';
import UserProfile from './userProfile/entry';

import SdkSession from './sdkSession';
import ReauthorizationFailure from './reauthorizationFailure';
import Endpoint from './endpoint';

/**
 *
 * @class SDK
 * @desc The BAM SDK manages all BAM platform service API interactions and simplifies client-side integrations.
 *
 */
export default class SDK {

    /**
     *
     * @access public
     * @returns {SDK.Account}
     *
     */
    static get Account() {
        return Account;
    }

    /**
     *
     * @access public
     * @returns {SDK.Commerce}
     *
     */
    static get Commerce() {
        return Commerce;
    }

    /**
     *
     * @access public
     * @returns {SDK.Configuration}
     *
     */
    static get Configuration() {
        return Configuration;
    }

    /**
     *
     * @access public
     * @returns {SDK.Content}
     *
     */
    static get Content() {
        return Content;
    }

    /**
     *
     * @access public
     * @returns {SDK.CustomerService}
     *
     */
    static get CustomerService() {
        return CustomerService;
    }

    /**
     *
     * @access public
     * @returns {SDK.Device}
     *
     */
    static get Device() {
        return Device;
    }

    /**
     *
     * @access public
     * @returns {SDK.Drm}
     *
     */
    static get Drm() {
        return Drm;
    }

    /**
     *
     * @access public
     * @returns {SDK.Identity}
     *
     */
    static get Identity() {
        return Identity;
    }

    /**
     *
     * @access private
     * @returns {SDK.Internal}
     *
     */
    static get Internal() {
        return Internal;
    }

    /**
     *
     * @access public
     * @returns {SDK.Logging}
     *
     */
    static get Logging() {
        return Logging;
    }

    /**
     *
     * @access public
     * @returns {SDK.Media}
     *
     */
    static get Media() {
        return Media;
    }

    /**
     *
     * @access public
     * @returns {SDK.Paywall}
     *
     */
    static get Paywall() {
        return Paywall;
    }

    /**
     *
     * @access public
     * @returns {SDK.Purchase}
     *
     */
    static get Purchase() {
        return Purchase;
    }

    /**
     *
     * @access private
     * @returns {SDK.Services}
     *
     */
    static get Services() {
        return Services;
    }

    /**
     *
     * @access public
     * @returns {SDK.Status}
     *
     */
    static get Status() {
        return Status;
    }

    /**
     *
     * @access public
     * @returns {SDK.Subscription}
     *
     */
    static get Subscription() {
        return Subscription;
    }

    /**
     *
     * @access private
     * @returns {SDK.Test}
     *
     */
    static get Test() {
        return {
            Sequences
        };
    }

    /**
     *
     * @access public
     * @returns {SDK.Token}
     *
     */
    static get Token() {
        return Token;
    }

    /**
     *
     * @access public
     * @returns {SDK.Session}
     *
     */
    static get Session() {
        return Session;
    }

    /**
     *
     * @access public
     * @returns {SDK.UserActivity}
     *
     */
    static get UserActivity() {
        return UserActivity;
    }

    /**
     *
     * @access public
     * @returns {SDK.UserProfile}
     *
     */
    static get UserProfile() {
        return UserProfile;
    }

    /**
     *
     * @access public
     * @returns {SdkSession}
     *
     */
    static get SdkSession() {
        return SdkSession;
    }

    /**
     *
     * @access public
     * @returns {ReauthorizationFailure}
     *
     */
    static get ReauthorizationFailure() {
        return ReauthorizationFailure;
    }

    /**
     *
     * @access public
     * @returns {Endpoint}
     *
     */
    static get Endpoint() {
        return Endpoint;
    }

}



// WEBPACK FOOTER //
// ./src/sdk.js